<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
        </ol>
        <div class="panel-body locationform">
          <div
            v-if="ErrorMessage"
            class="alert-danger alert visibility"
            role="alert"
          >
            {{ ErrorMessage }}
          </div>
          <div
            v-if="SuccessMessage"
            class="alert-info alert visibility"
            role="alert"
          >
            {{ SuccessMessage }}
          </div>
          <div class="row">
            <div class="col-md-4">
              <form @submit.prevent="submitForm">
              <div class="form-group">
                      <label>Add Your Coupon</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Add Your Coupon"
                        v-model="couponData.coupons"
                      />
                        <button
                      
                            class="btn-raised btn-primary btn fixcolorAs "
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Accumulate</span>
                          </button>
                    </div>
              </form>
            </div>

            <div class="col-md-4">
              <div class="card-counter primary">
                <i class="fa fa-database"></i>
                <span class="count-numbers">{{UserCouponData.AvailablePoints}}</span>
                <span class="count-name">Redeemable Points</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card-counter danger">
                <i class="fa fa-ticket"></i>
                <span class="count-numbers">{{UserCouponData.TotalPoints}}</span>
                <span class="count-name">Total Points</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import chield from './components/child';
import UserService from '../services/user.service';
import commonServices from '../services/common-services';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import ModelSelectEnquery from './components/ModelSelectEnquery';
import VeeValidate from 'vee-validate';
function initialState() {
  return {
        coupons: ''
      }
}
export default {
  name: 'generateCoupons',
  data() {
    return {
      UserCouponData:{
         AvailablePoints:0,
        TotalPoints:0,
      },     
      loading: false,
      SuccessMessage:'',
      ErrorMessage:'',
       couponData: initialState(),
    };
  },
  components: { vSelect, ModelSelectEnquery },
  computed: {},
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted(){
    this.getDashboardCount();
  },
  methods: {
     submitForm() {
      this.$validator.validateAll().then((res) => {
        
        if (!res) {
          // handle input errors.
          this.ErrorMessage = 'Please Fill all menditory Options';
            setTimeout(() => (this.ErrorMessage = false), 5000);
          return;
        }
        if (res) {
          UserService.postMetod(
            'kspgAPI/CouponOperations/scan',
            this.couponData
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                for (const [key, value] of Object.entries(response.data.data)) {
                      if(value['status'] === "Accumulated"){
                        this.SuccessMessage = value['status']+":"+value['coupon'];
                        } else if(value['status'] === "Accumulate"){
                        this.SuccessMessage = +value['status']+":"+value['coupon'];
                      } else {
                        this.ErrorMessage = "Error "+value['status']+":"+value['coupon'];
                      }
                      
                    }

                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
              this.getDashboardCount()
            },
            (error) => {
              this.loading = false;

              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        } else {
          this.ErrorMessage = 'Please correct all error!';
        }
      });
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (this.SuccessMessage = false), 5000);
    },
    getDashboardCount(){
      let loader = this.$loading.show();
       commonServices
        .get('kspgAPI/CouponOperations/points', {})
        .then((response) => {
          const {
            data
          } = response.data;
          this.UserCouponData = data;
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 2000)
    },
     resetWindow: function () {
      Object.assign(this.$data.couponData, initialState());
    }
  },
};
</script>
<style>
.visibility {
  visibility: visible !important;
}
.card-counter {
  box-shadow: 2px 2px 10px #dadada;
  margin: 5px;
  padding: 20px 10px;
  background-color: #fff;
  height: 100px;
  border-radius: 5px;
  transition: 0.3s linear all;
}

.card-counter:hover {
  box-shadow: 4px 4px 20px #dadada;
  transition: 0.3s linear all;
}

.card-counter.primary {
  background-color: #007bff;
  color: #fff;
}

.card-counter.danger {
  background-color: #ef5350;
  color: #fff;
}

.card-counter.success {
  background-color: #66bb6a;
  color: #fff;
}

.card-counter.info {
  background-color: #26c6da;
  color: #fff;
}

.card-counter i {
  font-size: 5em;
  opacity: 0.2;
}

.card-counter .count-numbers {
  position: absolute;
  right: 35px;
  top: 20px;
  font-size: 32px;
  display: block;
}

.card-counter .count-name {
  position: absolute;
  right: 35px;
  top: 65px;
  font-style: italic;
  text-transform: capitalize;
  opacity: 0.5;
  display: block;
  font-size: 18px;
}
</style>